<template lang="pug">
  div.customSelect.e-suggestion
    input(
      :style="inputStyle"
      :ref="name"
      autocomplete="off"
      @focus.self="onFocus"
      :class="hasError ? 'is-invalid customSelect__select' : 'customSelect__select'"
      :placeholder="placeholder"
      @click.prevent.stop.self="onClick"
      :name="name"
      @keyup.enter.stop.prevent="onEnter"
      @input="onInput"
      :disabled="disabled"
      v-model="model[name]"
    )
    span.close--small(
      v-if="model[name]"
      title="Очистить поиск"
      @click="clearSearchInput"
    )
    
    template
      span(v-if="!disabled" @click="toggleList()").choose
      div(v-if="listOpened && !dontShowErrorInFinishComponent && error").customSelect__list.cuscroll.open.error-list
        ul
          li
            div
              div.small.partial-error.error {{error}}
      div(v-else-if="showedSuggestions && showedSuggestions.length > 0 && listOpened === true && model[name] && model[name].length >= minSuggestLen").customSelect__list.cuscroll.open.list
        e-perfect-scrollbar
          ul
            li(v-for="(item, idx) in showedSuggestions" :key="idx" @click="selectItem(item)" :class="{'border-bottom-grey-thin': addBorder}")
              div
                div(v-html="item[nameKey]")
                span.text-small.add-info(v-if="addInfo && item[addInfoField]" v-html="item[addInfoField]")
      div(v-else-if="listOpened").customSelect__list.cuscroll.open.help
        ul
          li
            div
              div.small(v-if="!model[name] || model[name].length <= minSuggestLen") Введите минимум {{minSuggestLen}} символа
              div.small(v-else) Ничего не найдено

</template>

<script>
  import world from '../../utils/word.js'
  import userFriendlyEr from '../../utils/userFriendlyEr.js'
  
  export default {
    name: 'e-suggestion',
    data() {
      return {
        leaveArea: false,
        error: null,
        listOpened: false,
        suggestInterval: null,
        hideSuggest: true,
        suggestions: [],
      }
    },
    props: {
      addBorder: {
        type: Boolean,
        default: false
      },
      addInfo: {
        type: Boolean,
        default: false
      },
      addInfoField: {
        type: String,
        default: 'address',
      },
      inputStyle: {
        type: Object,
        default: () => {
        }
      },
      realName: {
        type: String,
        default: null
      },
      nameKey: {
        type: String,
        default: 'name'
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: 'Начните вводить текст...'
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      suggestDelay: {
        type: Number,
        default: 300
      },
      minSuggestLen: {
        type: Number,
        default: 2
      },
      suggestionEndpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (ctx, value) {
          return null
        }
      },
      transformSuggestions: {
        type: Function,
        default: function (ctx, data) {
          return data
        }
      },
      useInnerSearch: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: function () {
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      transformRequest: {
        type: Array,
        // eslint-disable-next-line
        default: () => ([function (data, headers) {
          return data
        }])
      },
      maxShowedOptions: {
        type: Number,
        default: 100
      },
      dontShowErrorInFinishComponent: {
        type: Boolean,
        default: false
      },
      validateAlias: {
        type: String,
        default: null
      }
    },
    computed: {
      showedSuggestions() {
        return this.suggestions.data ? this.suggestions.data : this.suggestions
      },
      hasError() {
        if (this.error) {
          return true
        }
        return false
      }
    },
    watch: {
      model: {
        handler: function (val, oldVal) {
          if (this.realName) {
            if (val[this.realName] !== oldVal[this.realName]) {
              this.setNameFromRealName()
            }
          }
        },
        deep: true
      }
    },
    created() {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
      this.setNameFromRealName()
    },
    destroyed() {
      window.removeEventListener('click', this.outerClick)
      
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      clearSearchInput(){
        this.model[this.name] = ''
        this.$refs[this.name].focus()
        this.$emit('clear');
      },
      setRealName(item) {
        if (this.realName) {
          if (item && item[this.valueKey]) {
            this.$set(this.model, this.realName, item[this.valueKey])
          } else {
            // this.$set(this.model, this.realName, '')
          }
        }
      },
      setNameFromRealName() {
        if (this.realName && this.options) {
          let selectedValue = this.options.find(v => v[this.valueKey] === this.model[this.realName])
          if (selectedValue) {
            this.model[this.name] = selectedValue[this.nameKey]
          }
        }
      },
      toggleList() {
        this.error = null
        this.listOpened = !this.listOpened
      },
      onEnter() {
        // clear if input data empty
        if (!this.model[this.name]) {
          this.cleanInputData()
        }
        this.$emit('enter', this.model[this.name])
      },
      cleanInputData() {
        if (this.realName) {
          this.$set(this.model, this.realName, '')
        }
        this.$emit('selectItem')
      },
      onClick() {
        this.listOpened = true
        this.$emit('click', this.model[this.name])
      },
      onFocus() {
        this.toggleList()
        this.$emit('focus', this.model[this.name])
      },
      onBlur() {
        this.listOpened = false
      },
      searchData(data, q) {
        let list = []
        this.error = null
        try {
          let regExp = world.getRegExp(q, 'i')
          list = data.filter(item => (item[this.nameKey].search(regExp) > -1 || (item.short_name && item.short_name.search(regExp) > -1)))
        } catch (e) {
          console.error(e)
          this.error = e.toString()
        }
        return list
      },
      searchFilter(data) {
        if (this.useInnerSearch) {
          if (this.inputStarted === false) {
            return data.slice(0, this.maxShowedOptions)
          }
          let founded = this.searchData(data, this.model[this.name])
          if (founded.length === 0) {
            return null
          }
          return founded
        } else {
          return data
        }
      },
      updateSuggestionsFromEndpoint(url) {
        let data = this.$sharedServices.store.getters.readUrlEndpoint(url)
        if (data) {
          this.suggestions = this.searchFilter(this.transformSuggestions(this, data))
        } else {
          this.suggestions = []
        }
      },
      onInput(e) {
        if (e) {
          this.inputStarted = true
        } else {
          this.inputStarted = false
        }
        if (this.suggestInterval) {
          clearInterval(this.suggestInterval)
        }
        
        if (!this.model.hasOwnProperty(this.name)) {
          this.$set(this.model, this.name, '')
        }
        
        // if suggestionEndpoint exist
        // show all awalaible varinats
        if (!this.useInnerSearch && !this.inputStarted) {
          return false
        }
        
        if (this.listOpened && this.model[this.name].length >= this.minSuggestLen) {
          this.$emit('search-change', this.model[this.name])
          let endpoint = this.suggestionEndpoint(this, this.model[this.name])
          if (endpoint) {
            // get from cache if exist
            let data = this.$sharedServices.store.getters.readUrlEndpoint(endpoint)
            if (data) {
              this.error = null
              this.updateSuggestionsFromEndpoint(endpoint)
            }
            // update cache
            this.suggestInterval = setInterval(() => {
              this.error = null
              this.$sharedServices.store.dispatch('updateUrlEndpoint', {
                endpoint,
                params: {
                  disableGlobalError: true,
                  transformRequest: this.transformRequest
                }
              }).then(() => {
                this.updateSuggestionsFromEndpoint(endpoint)
              }).catch(e => {
                console.error(e)
                this.error = userFriendlyEr.recognize(e, endpoint)
              })
              
              clearInterval(this.suggestInterval)
            }, this.suggestDelay)
          } else {
            this.error = null
            this.suggestions = this.searchFilter(this.options)
          }
          return true
        }
        
        this.suggestions = []
        return false
      },
      selectItem(item) {
        this.listOpened = false
        this.setRealName(item)
        this.setNameFromRealName()
        this.$emit('elOutFocus', this)
        this.$emit('selectItem', item)
      },
      getElement() {
        return this.$refs[this.name]
      },
      validate() {
        let msg = ''
        if (this.required) {
          if (!this.model[this.name] || this.model[this.name].length < 1) {
            msg = 'Заполните поле'
          }
          
          if (this.realName) {
            if (!this.model[this.name]) {
              msg = 'Заполните поле'
            } else if (!this.model[this.realName]) {
              msg = 'Необходимо выбрать значение из списка'
            }
          }
        }
        
        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          /* dont focus, лень думать как это должно работать */
          //el: this.getElement()
        }
      }
    }
  }
</script>
<style scoped>

</style>